import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { PersonalDevelopmentPlan } from 'types/pdp';
import { API_PDP_LIST } from 'constants/api';
import { RootState } from 'store';
import qs from 'query-string';

export const getUserPDPs = createAsyncThunk<
  PersonalDevelopmentPlan[],
  { userId: number }
>('pdp/getUserPDPs', async ({ userId }, { rejectWithValue, getState }) => {
  const state = getState() as RootState;
  const { filters } = state.pdpUser;

  return api.axios
    .get(
      `${API_PDP_LIST}?${qs.stringify(
        { ...filters, userId },
        { skipNull: true },
      )}`,
    )
    .then((res) => res.data.data)
    .catch((e) => rejectWithValue(e.response?.data));
});
